const AGREE_STATUS: string = 'agree';
const DISAGREE_STATUS: string = 'disagree';
const WAIT_STATUS: string = 'wait';

export {
    AGREE_STATUS,
    DISAGREE_STATUS,
    WAIT_STATUS,
};